import {useSelector} from 'react-redux'

/**
 * Custom React Hook to get random.org API response from state.
 * @see https://reactjs.org/docs/hooks-custom.html
 */
// const useCurrentPageAPI = () => {
//   return useSelector(state => {
//     // eslint-disable-next-line no-console
//     // console.debug(state.currentPage)
//     return state.currentPage
//   })
// }
const useCurrentPageAPI = () =>
  useSelector(state => ({
    currentPage: state.currentPage.currentPage,
    currentEnv: state.currentPage.currentEnv
  }))
export default useCurrentPageAPI
